import { render, staticRenderFns } from "./EditSocialIcons.vue?vue&type=template&id=389b716a&"
import script from "./EditSocialIcons.vue?vue&type=script&lang=js&"
export * from "./EditSocialIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports